import { render, staticRenderFns } from "./MenuBreakfastSectionItem.vue?vue&type=template&id=d45a4596&"
import script from "./MenuBreakfastSectionItem.vue?vue&type=script&lang=ts&"
export * from "./MenuBreakfastSectionItem.vue?vue&type=script&lang=ts&"
import style0 from "./MenuBreakfastSectionItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VDivider,VRow,VSwitch})
